import React, { useState } from "react";
import style from './mobileFilters.module.scss';
import Switch from "../../SelectionControls/Switch/Switch";
import EditDropDown from "../../Dropdown/EditDropDown/DropDown"

const MobileFilters = (props) => {
    const [modal, setModal] = useState({ open: false })
    return (
        <div className={style.wrapper}>
            <div className={props.isFiltersSelected && props.isFiltersSelected.includes(true) ? style.filterButtonsWrapperSelected : style.filterButtonsWrapper} onClick={() => setModal({ ...modal, open: !modal.open })}>
                <div className={style.icon}></div>
                <p className={style.text}>فیلترها</p>
            </div>

            <div className={modal.open ? style.modalOpen : style.modalClose}>
                <div className={style.header}>
                    <h4 className={style.upperTitleText}>فیلترها</h4>
                    <span onClick={() => setModal({ ...modal, open: !modal.open })} className={style.close}>
                        <span className={style.cancelModal}>e</span>
                    </span>
                </div>

                <div className={style.filterWrapper}>
                    {props.FilterArrays && props.FilterArrays.map((filter, index) => {
                        return <div key={index}>
                            <EditDropDown
                                tag={filter.tag}
                                label={filter.name}
                                dropdownList={filter.tag !== 'promotion' ? props.filterData[`${filter.tag}${filter.tag !== 'salesStatus' ? 's' : ''}`] : [{ name: "بدون تغییر قیمت", checked: props.getFromUrl('withoutchangeprice') },
                                { name: "فعال‌سازی ربات در تخفیف هوشمند", checked: props.getFromUrl('activerobotinpromotions') }]}
                                hasCheckbox={true}
                                handleSelect={filter.tag !== 'promotion' ? props.selectHandler : props.handleSelect}
                                deleteSelectedItems={props.deleteAll}
                                errorMessage=''
                            />
                        </div>
                    })}
                    {props.switchFilter && Object.keys(props.switchFilter).map((switchItem, switchIndex) => <div className={style.switchClass} key={switchIndex}>
                        <Switch
                            value={props.getFromUrl(switchItem)}
                            indeterminate={false}
                            disabled={false}
                            tag={switchItem}
                            label={props.switchFilter[switchItem].name}
                            onclick={(e, val, tag) => {
                                props.setToUrl(!val, tag)
                            }} />
                    </div>)}
                </div>
            </div>
        </div>
    )
}
export default MobileFilters